import React, { useEffect } from "react";
import Navbar from "../components/homepage/Navbar";
 
import { TenderDetails } from "../components/tenders/TenderDetails";
import { Header, Footer } from "../shared";

const TenderDetailsPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div>
      <div className="bg_darkblue">
        <Header />
      </div>
      <TenderDetails />
      <Footer />
    </div>
  );
};

export default TenderDetailsPage;
